var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTextarea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 16.001 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_Text-area",
    d: "M10474.463-8844.758a1,1,0,0,1-1-1v-12a1,1,0,0,1,1-1h14a1,1,0,0,1,1,1v12a1,1,0,0,1-1,1Zm.5-1.5h13v-11h-13Zm10.288-.629v-.942h1.161v-1.19h1v2.133Zm-8.321-4.634v-3.827h-1.366v-1.153h3.869v1.153h-1.424v3.827Z",
    transform: "translate(-10473.462 8858.758)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTextarea);
export default __webpack_public_path__ + "static/media/icon_textarea.8171619a.svg";
export { ForwardRef as ReactComponent };